import React from 'react';
import './Onboarding.css';
import logo from '../logo.jpg';

const OnboardingLayout = ({ children, hideLeft = false }) => (
  <div className="bg-onboarding-gradient d-flex align-items-center py-5">
    <div className="container">
      <div className={`row align-items-center justify-content-center ${hideLeft ? '' : 'gy-5'}`}>
        {!hideLeft && (
          <div className="col-lg-5 text-white text-center text-lg-start">
            <div className="d-flex align-items-center justify-content-center justify-content-lg-start mb-4">
             <div className="logo-placeholder me-3">
                         <img src={logo} className='rounded-circle' alt="IEEE Logo" width="75" />
                       </div>  
              <h5 className="mb-0 fw-bold">IEEE Study Groups</h5>
            </div>
            <h1 className="display-4 fw-bold">Welcome ..</h1>
            <p className="lead opacity-75">You can walk the steps with us to start your journey</p>
          </div>
        )}
        <div className={`col-lg-${hideLeft ? '10' : '6'} d-flex justify-content-center`}>
          <div className="card card-onboarding p-4 p-md-5 bg-white w-100" style={{ maxWidth: hideLeft ? '900px' : '520px' }}>
            {children}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default OnboardingLayout;